export default __webpack_public_path__ + "static/media/hac.b32b3ced.png";